
import * as Mui from "@mui/material";
import { InputProps } from "./Types";
import { destructProps, useFormInputs } from "./Utils";

const FormTextField = (props: InputProps) => {
  const { formProps, baseProps } = destructProps<InputProps>(props);

  const form = useFormInputs(formProps);

  const error = baseProps.error || !!form?.error;
  const helperText = baseProps.helperText || form?.error?.message?.toString() || "";
  return (
    <Mui.TextField
      name={formProps.name}
      {...baseProps}
      value={form?.value}
      onChange={(val) => form?.onChange && form?.onChange(val.currentTarget.value)}
      error={error}
      helperText={helperText}
    />
  );
}

export default FormTextField